import React, { useState } from "react";
import { DigitalLiteSwitchModal } from "./digital-lite-switch-modal";
import { useDigitalLiteModal } from "../../shared/hooks/use-digital-lite-modal";
import { ToggleSwitch } from "../form-inputs/inputs";
import "./digital-lite-switch.scss";

export const DigitalLiteSwitch = ({ codingWipKey, upc, saveCodingWipKey = false }) => {
    const [isToggled, setToggle] = useState(false);
    const modalProps = useDigitalLiteModal(codingWipKey, saveCodingWipKey, () => setToggle(false));

    const handleToggle = (name, value) => {
        if (value) {
            setToggle(true);
            modalProps.openModal(true);
        }
    };

    return (
        <>
            <ToggleSwitch name="isToggled" value={isToggled} label="Switch to digital lite" updateOnChange={handleToggle} />
            <DigitalLiteSwitchModal {...modalProps} upc={upc} />
        </>
    );
};
